import * as angular from 'angular';
import * as _ from 'lodash';
import { IDebugHelper } from 'v2/modules/core/debug-helper';
import { IV3ModelHelper } from 'v2/modules/core/v3-model-helper';

interface ICtrlScope extends ng.IScope {
  passwordMinLength: number;
  params: {
    id: number;
    email: string;
    password: string;
    password_confirmation: string;
  };
  meta: {
    role: string;
  };
  activationTokenType: string;
  activationTokenParams: {};
  user: v3.resource.IUser;
  stateUI: {
    ready: boolean;
    loading: boolean;
    error: string;
  };
  submitForm: (form: ng.IFormController) => void;
  redirectAfterSuccess: () => void;
}

angular.module('cerego.v3Registration').controller('invitationCtrl', [
  '$scope',
  '$window',
  '$routeParams',
  'DebugHelper',
  'UserManager',
  'V3ModelHelper',
  'V3UsersResource',
  'V3ActivationTokensResource',
  (
    $scope: ICtrlScope,
    $window: ng.IWindowService,
    $routeParams: ng.route.IRouteParamsService,
    DebugHelper: IDebugHelper,
    UserManager: v3.service.IUserManager,
    V3ModelHelper: IV3ModelHelper,
    V3UsersResource,
    V3ActivationTokensResource
  ) => {
    DebugHelper.register('invitationCtrl', $scope);

    $scope.stateUI = {
      ready: false,
      loading: true,
      error: null
    };
    $scope.params = {
      id: null,
      email: '',
      password: '',
      password_confirmation: ''
    };

    $scope.submitForm = form => {
      form.submitted = true;
      if (!form.$valid || $scope.params.password !== $scope.params.password_confirmation) {
        return;
      }

      $scope.params.id = $scope.user.id;
      $scope.stateUI.loading = true;
      const params = _.pick($scope.params, ['id', 'name', 'password', 'password_confirmation']);
      _.assignIn(params, $scope.activationTokenParams);
      return V3UsersResource.update(
        params,
        { include: 'emails' },
        success => $scope.redirectAfterSuccess(),
        error => {
          $scope.stateUI.loading = false;
          return ($scope.stateUI.error = V3ModelHelper.humanizeV3Error(error.data));
        }
      );
    };

    $scope.redirectAfterSuccess = () => {
      switch ($scope.activationTokenType) {
        case 'partner_invitation':
          if ($scope.meta.role === 'admin') {
            $window.location.href = Packs.iKnowRoutes.v3_partner_dashboard_path($scope.meta['partner-id']);
          } else if ($scope.meta.role === 'course manager' || $scope.meta.role === 'instructor') {
            $window.location.href = Packs.iKnowRoutes.v3_courses_path();
          } else {
            $window.location.href = Packs.iKnowRoutes.v2_sets_path({ partnerId: $scope.meta['partner-id'] });
          }
          break;
        case 'editor_invitation':
          $window.location.href = Packs.iKnowRoutes.v2_create_set_path($scope.meta['set-id']);
          break;
        default:
          throw new Error('Unexpected activation token type');
      }
    };

    $scope.$on('$routeChangeSuccess', ($event, current, previous) => {
      $scope.activationTokenType = current.locals.$tokenKey;
      $scope.activationTokenParams = {
        activation_token: $routeParams.token,
        activation_token_type: $scope.activationTokenType
      };
      V3ActivationTokensResource.get(
        $scope.activationTokenParams,
        success => {
          $scope.user = V3ModelHelper.parseObject(success).data;
          $scope.passwordMinLength = success.meta['min-password-length'];
          $scope.params.email = $scope.user.attributes.email;
          $scope.meta = success.meta;
          $scope.$emit('registration:UserStatusChanged', $scope.user);
          $scope.stateUI.ready = true;
          $scope.stateUI.loading = false;
        },
        error => {
          // Handle this case. Tell them link is invalid or something.
          $scope.stateUI.loading = false;
          $scope.stateUI.error = 'This invitation link is either invalid or already used';
        }
      );
    });
  }
]);
